import { alpha, Theme } from '@mui/material/styles';

export const getColorIcon = (
  theme: Theme,
  isDark: boolean,
  isBuyerUser: boolean
) => {
  if (!isBuyerUser) {
    theme.palette.error.main;
  }
  if (isDark) {
    theme.palette.success.main;
  }
  if (!isDark && isBuyerUser) {
    return '#6acd2f';
  }
};
export const getColorStatusText = (
  theme: Theme,
  isBuyerUser: boolean,
  isDark: boolean
) => {
  if (isBuyerUser && !isDark) {
    return '#6ace2e';
  }
  if (isBuyerUser) {
    return theme.palette.success.main;
  }
  return 'inherit';
};

export const getButtonContained = (theme: Theme) => ({
  backgroundColor: theme.palette.primary.main,
  backgroundImage: 'none',
  mt: 1,
  px: 2,
  [theme.breakpoints.down('sm')]: { mt: 3, mb: 0 },
  [theme.breakpoints.up('lg')]: { mt: 2, mb: 0, px: 4 },
  [theme.breakpoints.up('xl')]: { px: 5 },
  '&:hover': {
    backgroundPosition: 'none',
    backgroundColor: alpha(theme.palette.primary.main, 0.4),
    transition: `background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
    color: theme.palette.primary.main,
    boxShadow: 'none'
  }
});
export const vestingCardStyles = (
  theme: Theme,
  isDark: boolean,
  isBuyerUser: boolean
) => ({
  card: {
    minHeight: 450,
    height: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
    px: 4,
    py: 3,
    width: '100%',
    [theme.breakpoints.down('md')]: {
      minHeight: 300
    },
    [theme.breakpoints.down('sm')]: {
      px: 3,
      py: 3.5,
      minHeight: 300
    },
    background: isDark
      ? 'linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.09))'
      : 'rgba(233, 240, 253, 0.5)',
    boxShadow: isDark
      ? 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px'
      : 'rgb(0 0 0 / 7%) 0px 8px 13px 2px',
    backdropFilter: isDark ? 'blur(40px)' : 'blur(4px)',
    backgroundBlendMode: 'overlay',
    '&:hover': {
      background: isDark
        ? `radial-gradient(circle at 40% 85%, ${alpha(
            theme.palette.primary.main,
            0.4
          )} 5%, rgba(255, 255, 255, 0.06) 40%) `
        : `radial-gradient(circle at 40% 90%, ${alpha(
            theme.palette.primary.main,
            0.15
          )} 15%, rgba(233, 240, 253, 0.5) 40%) `
    }
  },
  subtitle: {
    textAlign: 'center'
  },
  wait: {
    textAlign: 'center',
    fontVariationSettings: "'wght' 600",
    [theme.breakpoints.down('sm')]: { fontVariationSettings: "'wght' 500" }
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      color: getColorIcon(theme, isDark, isBuyerUser)
    }
  },
  text: {
    textAlign: 'center',
    fontVariationSettings: "'wght' 400",
    pb: 0.25,
    [theme.breakpoints.down('md')]: { pb: 0 }
  },
  dataContainer: {
    pt: 2
  },
  dataTitle: {
    fontVariationSettings: isDark ? "'wght' 400" : "'wght' 300",
    [theme.breakpoints.down('md')]: { pb: 0.5 }
  },
  dataNumber: {
    [theme.breakpoints.down('md')]: {
      fontVariationSettings: isDark ? "'wght' 500" : "'wght' 400"
    }
  },
  cell: {
    borderBottom: isDark
      ? '0.25px solid #ffffff4d'
      : `0.1px solid ${alpha(theme.palette.secondary.main, 0.4)}`,
    [theme.breakpoints.down('md')]: { borderBottom: 'none' },
    [theme.breakpoints.down('sm')]: {
      borderBottom: isDark
        ? '0.25px solid #ffffff4d'
        : `0.1px solid ${alpha(theme.palette.secondary.main, 0.4)}`
    },
    py: 1.5
  },
  rowContainer: {
    [theme.breakpoints.down('md')]: {
      borderBottom: isDark
        ? '0.25px solid #ffffff4d'
        : `0.1px solid ${alpha(theme.palette.secondary.main, 0.4)}`
    },
    [theme.breakpoints.down('sm')]: { borderBottom: 'none' }
  },
  rowContainerWallet: {
    mt: 1
  },
  circleIcon: { fontSize: 8, mr: 0.75 },
  button: {
    '&.MuiButton-sizeSmall': {
      width: '100%',
      height: 32,
      backgroundColor: theme.palette.primary.main,
      border: 'none',
      borderRadius: '6px',
      color: '#fff',
      py: 3,
      mt: 1,
      [theme.breakpoints.down('sm')]: { width: '100%' },
      [theme.breakpoints.up('sm')]: { display: 'flex' },
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.1),
        transition: `background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
        color: theme.palette.primary.main,
        boxShadow: 'none'
      },
      '&:disabled': {
        color: 'rgba(173, 172, 172, 0.5)',
        background: 'rgba(139, 139, 139, 0.15)'
      }
    }
  },
  rectangle: {
    borderRadius: '7px'
  },
  dataSubtitle: {
    pl: 0.75,
    pr: 0.5,
    fontVariationSettings: "'wght' 400"
  },
  seeTransactionsLink: {
    textDecoration: 'none',
    pt: 1,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  seeTransactionsLinkIcon: { fontSize: 15, ml: 0.75 },
  textStatus: {
    fontVariationSettings: isBuyerUser ? "'wght' 400" : "'wght' 200",
    color: getColorStatusText(theme, isBuyerUser, isDark)
  },
  containerTitleAndHelper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  }
});
